import { render, staticRenderFns } from "./tipall.vue?vue&type=template&id=308bbdb8&scoped=true"
import script from "./tipall.vue?vue&type=script&lang=js"
export * from "./tipall.vue?vue&type=script&lang=js"
import style0 from "./tipall.vue?vue&type=style&index=0&id=308bbdb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308bbdb8",
  null
  
)

export default component.exports